<template>
  <div class="normal-btn" :class="{disabled,round,loading}" @click="handleClick">
    <slot></slot>
  </div>
</template>
<script>

export default {
  components: {},
  props: {
    disabled: Boolean,
    round: Boolean,
    loading: Boolean
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    handleClick(event) {
      if (this.disabled) {
        return;
      }
      if (this.loading) {
        return;
      }
      this.$emit('click', event);
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  }
}
</script>

<style lang="scss" scoped>
.normal-btn {
  height: 44px;
  line-height: 44px;
  background-color: #00A1D3;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  //
  font-size: 14px;
  color: #ffffff;
  user-select: none;
  //
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 161, 211, 0.7);
  }

  &:active {
    background-color: rgba(0, 161, 211, 0.5);
  }

  //
  &.disabled,
  &.loading {
    cursor: not-allowed;

    &,
    &:hover,
    &:active {
      background-color: rgba(0, 161, 211, 0.5);
    }
  }

  &.loading {
    cursor: wait;
  }

  &.round {
    border-radius: 22px;
  }
}
</style>
